import { PropsWithChildren, createContext, useEffect, useState } from 'react';

import Cookies from 'js-cookie';

import { updateMe } from '~/modules/auth/libs/apis';

import type { ExtendedWindow } from '../libs/types';

declare let window: ExtendedWindow;

export interface FCMContextValue {
  fcmToken?: string;
}

export const FCMContext = createContext<FCMContextValue>({});

/**
 * 네이티브와 브릿지 메서드로 통신하여 FCM 토큰을 갱신하는 역할을 합니다.
 * - 유저 정보에 접근할 수 있어야 하기 때문에 AuthProvider 하위에 위치해야 합니다.
 * - 로그인 상태에서만 유효하기 때문에 (privated) 폴더 하위에 위치해야 합니다.
 */
export const FCMProvider = (props: PropsWithChildren) => {
  const { children } = props;

  const [fcmToken, setFcmToken] = useState('');

  const updateFcmToken = async (token: string) => {
    try {
      const appName = Cookies.get('APP_NAME');
      const deviceType = Cookies.get('DEVICE');
      const version = Cookies.get('VERSION');
      const buildNumber = Cookies.get('BUILDNUMBER');

      await updateMe({
        appListData: {
          appName: appName || 'caasclient',
          appInfo: {
            deviceType,
            version,
            buildNumber,
            userAgent: navigator.userAgent,
            fcmToken: token,
            pushEnabled: true,
            appStatus: true,
          },
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fcmTokenCookie = Cookies.get('FCM_TOKEN');
    if (fcmTokenCookie) {
      updateFcmToken(fcmTokenCookie);
      setFcmToken(fcmTokenCookie);
    }

    window.onFcmInfoSuccess = (token: string) => {
      console.log(`[FCMContext] onFcmInfoSuccess`, token);
      updateFcmToken(token);
      setFcmToken(token);
    };

    return () => {
      delete window.onFcmInfoSuccess;
    };
  }, []);

  return <FCMContext.Provider value={{ fcmToken }}>{children}</FCMContext.Provider>;
};
